export default async function ({
  store,
  app
}) {
  await store.dispatch('age-restrictions/fetch', {
    params: {
      count: 100500,
      lang: app.i18n.locale
    }
  })
}
